// Turns stored enum/code values ("in_progress", "bank-transfer", "nhs voucher")
// into the sentence-case text a UK practice expects to read ("In progress",
// "Bank transfer", "NHS voucher"). Values that already carry capitals are
// left alone so hand-written labels are never mangled.

/** Abbreviations that must stay upper case wherever they appear. */
const ACRONYMS = new Set([
  'nhs',
  'gos',
  'gos1',
  'gos3',
  'gos4',
  'gos6',
  'vat',
  'bacs',
  'pcse',
  'gp',
  'id',
  'iop',
  'cl',
  'sms',
  'pdf',
  'csv',
  'po',
  'uk',
  'mecs',
  'cues',
  'pe',
]);

export function formatLabel(value: string | null | undefined, fallback = '—') {
  const raw = (value ?? '').trim();
  if (!raw) return fallback;
  // Already cased by a person ("Up to date", "GOS3 claim"): keep it.
  if (/[A-Z]/.test(raw)) return raw;
  const words = raw.replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').split(' ');
  return words
    .map((word, i) => {
      if (ACRONYMS.has(word)) return word.toUpperCase();
      return i === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word;
    })
    .join(' ');
}

/**
 * Upper-cases the known acronyms inside a label while leaving the rest alone,
 * for text that CSS `capitalize` would turn into "Nhs Claims" / "Finance & Vat".
 */
export function upperAcronyms(text: string) {
  return text.replace(/[A-Za-z0-9]+/g, (word) =>
    ACRONYMS.has(word.toLowerCase()) ? word.toUpperCase() : word,
  );
}
